// compareTo.$inject = ['$filter'];
import providerSideMenuTemplate from './views/providers-side-menu.html';
import toolboxFilterTemplate from './views/filter-toolbox.html';
import toolboxPaginationTemplate from './views/pager-toolbox.html';
function compareTo() {
  return {
    require: "ngModel",
    scope: {
      otherModelValue: "=compareTo"
    },
    link: function link(scope, element, attributes, ngModel) {
      ngModel.$validators.compareTo = modelValue =>  {
        return modelValue === scope.otherModelValue;
      };
      scope.$watch("otherModelValue", () => {
        ngModel.$validate();
      });
    }
  };
}

function upperCase(){
  return{
    restrict: 'EA',
    require: 'ngModel',
    link: function(scope, element, attr, ngModel){
      ngModel.$parsers.push(function(value){
        if(!value)return null;
        let newVal = value.toUpperCase();
        ngModel.$setViewValue(newVal);
        ngModel.$render();
        return newVal;
      });
      ngModel.$formatters.push(function(value){
        if(!value || !angular.isString(value))return;
        return value.toUpperCase();
      });
    }
  };
}

function providerSideMenu(){
  return {
    restrict: 'A',
    template: providerSideMenuTemplate
  };
}

function toolboxFilter(){
  return {
    restrict: 'A',
    template: toolboxFilterTemplate
  };
}

function toolboxPagination(){
  return {
    restrict: 'A',
    template: toolboxPaginationTemplate
  };
}

function ngEnter(){
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.ngEnter);
        });
        
        event.preventDefault();
      }
    });
  };
}

function checkStrength() {
  return {
    replace: false,
    restrict: 'EACM',
    link: function link(scope, iElement, iAttrs) {
  
      let strength;
      strength = {
        colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
        mesureStrength(p) {
          let _force = 0;
          //let _regex = /[$-/:-?{-~!"^_`\[\]]/;
          let _regex = /[$-/:-?-~!^_`\[\]]/;
      
          let _lowerLetters = /[a-z]+/.test(p);
          let _upperLetters = /[A-Z]+/.test(p);
          let _numbers = /[0-9]+/.test(p);
          let _symbols = _regex.test(p);
      
          let _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
          let _passedMatches = $.grep(_flags, function (el) {
            return el === true;
          }).length;
      
          _force += 2 * p.length + (p.length >= 10 ? 1 : 0);
          _force += _passedMatches * 10;
      
          // penality (short password)
          _force = p.length <= 6 ? Math.min(_force, 10) : _force;
      
          // penality (poor letiety of characters)
          _force = _passedMatches == 1 ? Math.min(_force, 10) : _force;
          _force = _passedMatches == 2 ? Math.min(_force, 20) : _force;
          _force = _passedMatches == 3 ? Math.min(_force, 40) : _force;
          return _force;
        },
        getColor: function getColor(s) {
          let idx = 0;
          if (s <= 10) {
            idx = 0;
          } else if (s <= 20) {
            idx = 1;
          } else if (s <= 30) {
            idx = 2;
          } else if (s <= 40) {
            idx = 3;
          } else {
            idx = 4;
          }
          return {
            idx: idx + 1,
            col: this.colors[idx]
          };
        }
      }; // let strength
      scope.$watch(iAttrs.checkStrength, () => {
        if (scope.password === '') {
          iElement.css({
            "display": "none"
          });
        } else {
          if (scope.password) {
            let c = strength.getColor(strength.mesureStrength(scope.password));
            scope.passwordStrength = c;
            iElement.css({
              "display": "inline"
            });
            iElement.children('li').css({
              "background": "#DDD"
            }).slice(0, c.idx).css({
              "background": c.col
            });
          }
        }
      }); // watch
    }, // link

    template: '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>'
  };
}


export default {
  compareTo,
  ngEnter,
  upperCase,
  providerSideMenu,
  toolboxPagination,
  toolboxFilter,
  checkStrength
};



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/directives/directives-simple.js
 **/